<template>
  <div class="container pt-3">
    <div class="main-header px-5 mb-6">
      <!-- Background image set with div -->

      <div
        class="image-background rounded"
        :style="{
          backgroundImage: 'url(' + require('@/assets/home-banner.jpg') + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
          height: 'fit-content', // Adjust height as needed
        }"
      >
        <div class="header-container rounded">
          <div class="hero-body pt-6 pb-5">
            <div class="header">
              <div class="columns is-multiline is-centered">
                <div class="column is-10-widescreen has-text-centered">
                  <h1
                    class="title is-3 is-size-4-mobile has-text-white has-text-weight-semibold fade-in-bottom"
                  >
                    Tech-Driven Solutions for Homestay Management, Renovation,
                    and Facility Care
                  </h1>
                  <p
                    class="is-hidden-mobile mt-1 is-size-6 has-text-white fade-in-bottom animation-delayer-02s has-text-weight-medium"
                  >
                    We offer streamlined, tech-driven solutions for managing
                    homestays, renovations, facility management and so on. From
                    automating bookings to overseeing renovations and
                    maintaining properties, our technology ensures efficiency,
                    quality, and peace of mind for property owners. Simplify
                    your property management with our innovative approach.
                  </p>
                  <p
                    class="is-hidden-tablet mt-1 is-size-6 has-text-white fade-in-bottom animation-delayer-02s has-text-weight-medium mb-4"
                  >
                    We offer streamlined, tech-driven solutions for managing
                    homestays, renovations, facility management and so on.
                  </p>
                  <b-button
                    @click="scrollToSection('WhyChooseUs')"
                    type="is-primary is-light"
                    class="my-2 is-fullwidth-touch large-button is-primary"
                  >
                    Learn more
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Partners/Platforms -->
    <div class="mb-6">
      <h1 class="has-text-centered title is-3 has-text-dark-gray mb-5">
        Our Partners
      </h1>
      <div class="scrolling-images">
        <div class="scroll-wrapper">
          <div
            v-for="(image, index) in images.concat(images)"
            :key="index"
            class="column is-narrow is-centered"
          >
            <b-image
              class="px-1"
              :src="require(`@/assets/${image.src}`)"
              :alt="image.name"
              :style="`margin-bottom: ${image.adjustPosition}`"
              style="width: 150px"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Content 1 -->

    <div class="has-text-centered pt-4-desktop mb-6 px-4">
      <div class="has-background-white accented-border-radius pt-6 pb-6">
        <div class="title is-4 mb-1" id="WhyChooseUs">
          Discover Our Unique Advantage
        </div>
        <p class="has-text-dark-grey is-size-6">
          Your trusted partner for managing the entire homestay hosting process,
          from renovation to daily maintenance.
        </p>
      </div>
      <div>
        <!-- <b-image :src="require(`@/assets/usp-1.png`)" unique-points.svg />
        <b-image :src="require(`@/assets/usp-2.png`)" unique-points.svg /> -->
        <div class="columns is-multiline is-8">
          <div
            v-for="(item, index) in cardData"
            :key="index"
            class="column is-one-third-widescreen is-half-desktop is-half-tablet is-full-mobile"
          >
            <div class="card rounded" style="height: 100%">
              <div class="card-content">
                <b-icon
                  :icon="item.icon"
                  class="icon"
                  size="is-medium"
                  type="is-primary"
                ></b-icon>
                <p class="usp-title is-size-4 has-text-weight-semibold mb-5">
                  {{ item.title }}
                </p>
                <p class="usp-desc is-size-6">{{ item.description }}</p>
                <p v-if="item.extra" class="subtitle">
                  <strong>{{ item.extraTitle }}:</strong> {{ item.extra }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        { name: "Airbnb", src: "airbnb-logo.png" },
        {
          name: "Booking",
          src: "booking-logo.png",
        },
        { name: "Agoda", src: "agoda-logo.png" },
        { name: "Trip", src: "trip-logo.png" },
        {
          name: "Traveloka",
          src: "traveloka-logo.png",
        },
        {
          name: "Time Internet",
          src: "time-logo.svg",
        },
        {
          name: "Unifi Internet",
          src: "unifi-logo.svg",
        },
        { name: "Allianz Insurance", src: "allianz-logo.svg" },
      ],
      cardData: [
        {
          title: "Legally Binding Digital Agreements",
          description:
            "Secure and compliant digital agreements ensure that all contracts are legally binding, providing ease and peace of mind for both parties.",
          icon: "pen",
        },
        {
          title: "Comprehensive All-In-One Digital Solution",
          description:
            "An all-encompassing platform that digitizes every aspect of the property management process, improving efficiency and reducing administrative tasks.",
          icon: "clipboard",
        },
        {
          title: "Secure Automated Payment Processing",
          description:
            "Automate rent and payment collections with secure systems, ensuring timely transactions and reduced manual intervention.",
          icon: "credit-card",
        },
        {
          title: "Efficient Property & Facility Management",
          description:
            "Streamline property and facility management with real-time updates and centralized tracking, making oversight simple and effective.",
          icon: "home",
        },
        {
          title: "Enhanced Financial Insights Improving Profitability",
          description:
            "Gain clear, actionable insights into your financials, helping you optimize for better profitability and informed decision-making.",
          icon: "chart-bar",
        },
        {
          title: "Streamlined Tenant Communication",
          description:
            "Centralized communication channels simplify interactions with tenants, leading to faster responses and improved tenant satisfaction.",
          icon: "comment",
        },
      ],
    };
  },
  methods: {
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.header-container {
  background: rgba(56, 56, 56, 0.5) !important;
  height: 100%;
}

.card {
  background-color: #fff;
  border: 1px solid #546baa;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  .usp-title {
    color: #414141;
  }
}

.card:hover {
  transform: scale(1.05); /* Scale up slightly */
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1); /* Add shadow on hover */
  background-color: #f8f8ff;
  border: 2px solid #3765e6;
  .usp-title {
    color: #315bce;
  }
  .usp-desc {
    color: #000;
  }
}

.icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

.card-title {
  font-weight: bold;
  font-size: 1.25rem;
  margin-bottom: 10px;
}

.card-description {
  font-size: 1rem;
  color: #666;
}

.cards-container {
}

@media (min-width: 768px) {
  .cards-container {
    grid-template-columns: 1fr 1fr; /* Half width on tablet */
  }
}

@media (min-width: 1024px) {
  .cards-container {
    grid-template-columns: 1fr 1fr 1fr; /* One third width on desktop */
  }
}
</style>
